import React from "react";
import { Outlet } from "react-router-dom";
import ChatsSidebar from "../Components/Chat/ChatsSidebar";
import { ThreadApiProvider } from "../Services/ThreadApiProvider";
import './Chats.css'

const Chats = ({ canEdit }) => {
  return (
    <ThreadApiProvider>
      <div className="main-chat d-flex flex-row">
        <ChatsSidebar />
        <Outlet context={{ canEdit }} />
      </div>
    </ThreadApiProvider>
  );
};

export default Chats;